function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (poker, tracked_stats) {
  var html = "<div class=\"poker-stats-overlay\">\n\t\t\t\t\t\t\t\t<div class=\"stats-table\">\n\t\t\t\t\t\t\t\t<div class=\"stats-table-header stats-table-row\">\n\t\t\t\t\t\t\t\t\t<div></div>\n\t";
  for (var p in poker.game.stats) {
    html += "<div title=\"".concat(p, "\">").concat(poker.app.keychain.returnUsername(p), "</div>");
  }
  html += "</div>";
  var _iterator = _createForOfIteratorHelper(tracked_stats),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      html += "<div class=\"stats-table-row\">";
      if (s !== null && s !== void 0 && s.further) {
        html += "<div class=\"stats-label label-note\" title=\"".concat(s.further, "\">").concat(s.readable, "*</div>");
      } else {
        html += "<div class=\"stats-label\">".concat(s.readable, "</div>");
      }
      for (var _p in poker.game.stats) {
        var stat_entry = "---";
        var playerStats = poker.game.stats[_p];
        var current_stat = playerStats[s.code];
        console.log(playerStats, s.code, current_stat);
        // Now we get a little fancy
        if (current_stat > 0) {
          if (s !== null && s !== void 0 && s.percentage) {
            var denom = playerStats["hands"];
            if (s.percentage == "adjusted") {
              denom -= playerStats["walks"];
            }
            if (denom > 0) {
              var percent = Math.round(100 * current_stat / denom);
              stat_entry = "".concat(percent, " (").concat(current_stat, "/").concat(denom, ")");
            }
          } else {
            stat_entry = current_stat;
          }
        }
        html += "<div>".concat(stat_entry, "</div>");
      }
      html += "</div>";
    }

    //close table and overlay
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += '</div></div>';
  return html;
};